(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ngb-answer-message"] && !Shopify.designMode) return;
  try {
    (() => {
    if (new URLSearchParams(window.location.search).get('message') !== 'answer') return;

    const notice = document.getElementById('ngb-answer-message');
    if (!notice) return;

    const dismiss = () => {
      notice.hidden = true;
      document.removeEventListener('keydown', onKeydown);
    };
    const onKeydown = (event) => {
      if (event.key === 'Escape') dismiss();
    };

    notice.querySelector('button').addEventListener('click', dismiss, { once: true });
    document.addEventListener('keydown', onKeydown);
    notice.hidden = false;
    requestAnimationFrame(() => {
      notice.querySelector('[role="status"]').textContent = notice.dataset.message;
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
